import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from '../actions';
import Services from '../components/Services';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps({ services, softwares }) {
  return {
    services,
    softwares,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Services);
